// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"859":"5160fe0f","3625":"5160fe0f","3778":"5160fe0f","5809":"5160fe0f"}[chunkId] + ".chunk.css";
};